export const convertToParserTokens = e => {
	const t = []
	let r = !1
	for (const s of e)
		switch (s.type) {
			case '{':
				return {errid: 'NO_LCURLY', start: s.start, end: s.end}
			case 'semicolon':
				return {errid: 'NO_SEMICOLON', start: s.start, end: s.end}
			case 'whitespace':
				;(r = !0), t.length > 0 && (t[t.length - 1].hasSpaceAfter = !0)
				break
			case 'EOF':
				break
			default:
				t.push({...s, hasSpaceBefore: r, hasSpaceAfter: !1}), (r = !1)
		}
	return t
}
